jQuery(document).ready(function($) {
  $(window).resize(function(e) {
    console.log('aaa');
//     if ($(window).width() >= 1160) {
//       $('header.main-header').removeClass('collapsed-navigation');
//     }
  });
});